(function () {
    'use strict';

    angular.module('ib-pmt-utils-module', [
        'ib-dates-module',
        'ib-pmt-tabs-module',
        'ib-pmt-datalayer-module',
        'ib-datalayer-ecommerce-module',
        'ib-pmt-telephone-module'
    ]);
})();